import { useState } from "react";
import { Link } from "react-router-dom";

import "./Services02.css";

import img1 from "./../../../img/services/rk-full-package.jpg";
import img2 from "./../../../img/services/zero-fade-beard.jpg";
import img3 from "./../../../img/services/regular-hair-beard.jpg";
import img4 from "./../../../img/services/zero-fade-taper-fade.jpg";
import img5 from "./../../../img/services/regular-hair-beard.jpg";
import img6 from "./../../../img/services/senior.jpg";
import img7 from "./../../../img/services/hot-towel.jpg";
import img8 from "./../../../img/services/buzz-cut.jpg";
import img9 from "./../../../img/services/beard-trim.jpg";
import img10 from "./../../../img/services/line-up.jpg";
import img11 from "./../../../img/services/hair-design.jpg";
import img12 from "./../../../img/services/black-mask-wax.jpg";
import img13 from "./../../../img/services/hair-wash.jpg";
import img14 from "./../../../img/services/kids-regular.jpg";
import img15 from "./../../../img/services/kids-zero-fade.jpg";

function Services02() {
  const [showAll, setShowAll] = useState(false);

  const services = [
    {
      id: 1,
      name: "RK Full Package",
      duration: "1 hr 30 min",
      price: "$79.99",
      img: img1,
    },
    {
      id: 2,
      name: "Zero Fade & Beard",
      duration: "1 hr",
      price: "$49.99",
      img: img2,
    },
    {
      id: 3,
      name: "Regular Hair & Beard",
      duration: "1 hr",
      price: "$47.99",
      img: img3,
    },
    {
      id: 4,
      name: "Zero Fade Or Taper Fade",
      duration: "45 min",
      price: "$32.99",
      img: img4,
    },
    {
      id: 5,
      name: "Regular Haircut",
      duration: "30 min",
      price: "$29.99",
      img: img5,
    },
    {
      id: 6,
      name: "Senior Haircut",
      duration: "30 min",
      price: "$26.99",
      img: img6,
    },
    {
      id: 7,
      name: "Hot Towel Shave",
      duration: "30 min",
      price: "$25.99",
      img: img7,
    },
    {
      id: 8,
      name: "Buzz Cut",
      duration: "15 min",
      price: "$19.99",
      img: img8,
    },
    {
      id: 9,
      name: "Beard Trim",
      duration: "15 min",
      price: "$22.99",
      img: img9,
    },
    {
      id: 10,
      name: "Line Up",
      duration: "15 min",
      price: "$14.99",
      img: img10,
    },
    {
      id: 11,
      name: "Hair Design",
      duration: "15 min",
      price: "from $10",
      img: img11,
    },
    {
      id: 12,
      name: "Black Mask, Wax Or Threading",
      duration: "15 min",
      price: "$10.99",
      img: img12,
    },
    {
      id: 13,
      name: "Hair Wash",
      duration: "15 min",
      price: "$4.99",
      img: img13,
    },
    {
      id: 14,
      name: "Kids Regular Haircut (12 or under)",
      duration: "30 min",
      price: "$24.99",
      img: img14,
    },
    {
      id: 15,
      name: "Kids Zero Fade (12 and under)",
      duration: "30 min",
      price: "$32.99",
      img: img15,
    },
  ];

  const displayedServices = showAll ? services : services.slice(0, 10);

  return (
    <div className="Services02 section" id="Services02">
      <div className="container">
        <div className="intro">
          <p className="eyebrow">Services</p>
          <h2>Our Services</h2>
          <p>Book your appointment for a modern cut.</p>
        </div>
        <div className="Services02-box">
          {displayedServices.map((service) => (
            <div key={service.id} className="Services02-card">
              <img src={service.img} alt="" />
              <div>
                <h3>{service.name}</h3>
                <Link to="/" className="small-font">
                  Read more
                </Link>
              </div>
              <p>{service.duration}</p>
              <p>{service.price}</p>
              <Link to="/book-now" className="small-font btn-2">
                BOOK NOW
              </Link>
            </div>
          ))}
        </div>

        {services.length > 10 && (
          <button className="btn-3" onClick={() => setShowAll(!showAll)}>
            {showAll ? "SHOW LESS" : "VIEW MORE"}
          </button>
        )}
      </div>
    </div>
  );
}

export default Services02;
